/* eslint-disable func-names */
import tmsMdmAxiosInstance from '@/tms-mdm-axios';

export const getVehicleTypes = async function (params) {
  try {
    return await tmsMdmAxiosInstance.get('/vehicle_type', { params });
  } catch (error) {
    throw error;
  }
};
